import classNames from "classnames";

import styles from "./ThinkingIndicator.module.css";

interface ThinkingIndicatorProps {
  size?: "medium" | "small";
}

export const ThinkingIndicator = ({
  size = "medium",
}: ThinkingIndicatorProps) => {
  const containerClass = classNames(styles.container, {
    [styles["container-small"]]: size === "small",
  });
  const dotClass = styles.dot;

  return (
    <div className={containerClass}>
      <div className={dotClass} />
      <div className={dotClass} />
      <div className={dotClass} />
    </div>
  );
};
